import http from "../utils/http"

/**
 * ปลั๊กอินมีอยู่หรือไม่
 * @param {object} params
 */
export function addonisexit(params) {
    return http({
        url: "/api/addon/addonisexit",
        data: params
    })
}
